export const pluralSuffix = (count: number) => {
  return count === 1 ? '' : 's';
};
